import React from "react";
import { Link } from "react-router-dom";

import {
  ArrayField,
  BooleanField,
  Button,
  Datagrid,
  TextField,
} from "react-admin";

import { BlankIcon, EditIcon, MoreIcon } from "../../../components/common/iconography";
import { AuditStatus } from "../../../utils/constants";

const LinkEditButton = ({ parsedAudit, record, ...props }) => {
  return (
    <Button
      label={parsedAudit.status !== AuditStatus.COMPLETED ? "Edit" : "Open"}
      color="primary"
      component={Link}
      to={{
        pathname: "/inventories/" + record.id,
        state: {
          backPath: props.location.pathname,
          audit:
            parsedAudit.status !== AuditStatus.COMPLETED
              ? parsedAudit
              : undefined,
        },
      }}
    >
      <EditIcon />
    </Button>
  );
};

const NoNotesIcon = () => (
  <BlankIcon color="disabled" style={{ display: "none" }} />
);

export const AuditReconcileTab = ({ record, ...props }) => {
  return (
    <ArrayField source="reconcileList" record={record} label="Reconcile List">
      <Datagrid rowClick={false}>
        <TextField source="accountName" label="Account" />
        <TextField source="productName" label="Product Name" />
        <TextField source="lotNumber" label="Lot Number" />
        <TextField source="locationFullName" label="Location" />
        <TextField source="quantityOnHand" label="Qty. On Hand" />
        <TextField source="quantityPhysical" label="Qty. Physical" />
        <TextField source="reconciledQuantityOnHand" label="Reco. On Hand" />
        <TextField source="reconciledQuantityPhysical" label="Reco. Physical" />
        <BooleanField
          source="seeNotes"
          label="Notes"
          fontSize="small"
          valueLabelTrue="see notes..."
          TrueIcon={MoreIcon}
          valueLabelFalse=""
          FalseIcon={NoNotesIcon}
        />
        <LinkEditButton {...props} parsedAudit={record} />
      </Datagrid>
    </ArrayField>
  );
};
